import React from 'react';
import styled from 'styled-components';
import { ACCENT_COLOR, BTN, NAME_SECTION, PADDING, FONTSIZETITLE } from '../styles/style';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useMemo } from 'react';
import cv_file from '../CV.pdf'

const Section = styled.section`
  height: auto;
  background-color: #212529;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  position: relative;
  a{color:${ACCENT_COLOR};}
  ${PADDING};
`;

const AnimatedText = styled(motion.div)`
  width: 100%;
    max-width: 1300px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;

    .title{
    position: relative;
    color:white;
    width: 100%;
    line-height: 3rem;
    ${FONTSIZETITLE};
    &::after{
      color:#f5f5f52b !important;
    content: "O MNIE";
    ${NAME_SECTION};
    width: 100%;
  }
  }
  .container-about-me{
    display: flex;
    gap:60px;
    flex-direction: column;
    @media(min-width:1024px){
      flex-direction: row;
      .info-person{
        max-width:340px;
        p{font-size:1rem !important;}
      }
    }
    margin-top:60px;
    @media(min-width:768px){margin-top:100px;}
    color:white;
    .description{
      text-align: left;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap:20px;
      h3{
        color:white;
        font-size:1.5rem;
        span{color:${ACCENT_COLOR};}
      }
      p{
        font-size:1.1rem;
      }
      color:#ffffff80;
    }
    .info-person{
      display: flex;
      flex-direction: column;
      width: 100%;
      text-align: left;
      p{
        padding: 10px 0;
        font-size:.8rem;
        border-bottom: 1px solid #7a7a7a38;
        &:last-child{border-bottom:0px solid gray !important;}
        
      }
      .btn{
        max-width: 220px;
        display: flex;
        justify-content: center;
        text-decoration: none;
        ${BTN};
      }
    }
    .container-skills{
      margin-top:20px;
      .title-container{
          /* color:white; */
          margin-bottom: 20px;
        }
      .skills{
        display: flex;
        gap:10px;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%; max-width: 500px;
        
        .skill{
          font-size: 1rem;
          padding: 5px 10px;
          border: 1px solid #7a7a7a38;
          border-radius: 10px;
          color:#fff;
          &:hover{
            color:black;
            background-color: #fff;
            cursor: default;
            border-radius: 1px solid #fff;
          }
        }
      }
    }
  }
`;

const About = () => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const skills = ['HTML5', 'CSS3', 'Scss', 'JavaScript', 'React', 'Chrome DevTools' ,'Python', 'WordPress', 'WooCommerce', 'Elementor', 'ACF', 'PHP', 'SQL', 'AI automation', 'Make', 'Git']
  const options = useMemo(() => ({
  triggerOnce: true,
  threshold: isMobile ? 0.1 : 0.6,
  rootMargin: isMobile ? '-60px 0px 0px 0px' : '-100px 0px 0px 0px',
}), []);

const [ref, inView] = useInView(options);
const exp = new Date().getFullYear() - 2020

  return (
    <Section id="about" ref={ref}>
      <AnimatedText
        initial={{ opacity: 0}}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 1.2, ease: 'easeOut' }}
      >
        <div className="title">
          <h2>Poznaj mnie bliżej!</h2>
          <p className="subtitle"></p>
        </div>
        <div className='container-about-me'>
          <div className='description'>
            <h3>Nazywam się <span>Wojtek Tałanda</span> i jestem Web Developerem z {exp}-letnim doświadczeniem.</h3>
            <p>Pracuję jako freelancer z klientami z Polski, oferując indywidualne podejście i kompleksowe wsparcie.
              <br/>Specjalizuję się w <strong>WordPress, WooCommerce, HTML, CSS, JavaScript i React</strong>. Tworzę strony internetowe, implementuję nowe funkcje, optymalizuję i zajmuję się administracją sklepów online.
              W swojej pracy korzystam z narzędzi opartych na <strong>AI</strong>, które pomagają mi efektywnie zarządzać czasem i usprawniać procesy.
              <br/><br/>Po godzinach stale się rozwijam — śledzę trendy w web developmencie i automatyzuję zadania w <a target='blank' href="https://www.make.com/">make.com</a>, by pracować szybciej i mądrzej.</p>
              <div className='container-skills'>
                  <p className='title-container'>W codziennej pracy wykorzystuję technologie takie jak:</p>
                  <div className='skills'>{skills.map((skill, index) => <p className='skill' key={index}>{skill}</p>)}</div>
              </div>
          </div>
          <div className='info-person'>
            <p><strong>Imię i nazwisko:</strong> Wojciech Tałanda</p>
            <p><strong>Email:</strong> talanda.wojciech@gmail.com</p>
            <p><strong>Telefon:</strong> (+48) 504 705 724</p>
            <p><strong>Wykształcenie:</strong> URZ - Ekonomia</p>
            <p><strong>Miasto:</strong> Rzeszów</p>
            <p><strong>Doświadczenie:</strong> {exp} lata</p>
            {/* <a className='btn' target='_blank' href={cv_file}>Pobierz CV</a> */}
          </div>
          
        </div>
      </AnimatedText>
    </Section>
  );
};

export default About;
